/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSingleSelectFieldOption
 */
export interface ControlSingleSelectFieldOption {
    /**
     * 
     * @type {string}
     * @memberof ControlSingleSelectFieldOption
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSingleSelectFieldOption
     */
    text: string;
}

/**
 * Check if a given object implements the ControlSingleSelectFieldOption interface.
 */
export function instanceOfControlSingleSelectFieldOption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function ControlSingleSelectFieldOptionFromJSON(json: any): ControlSingleSelectFieldOption {
    return ControlSingleSelectFieldOptionFromJSONTyped(json, false);
}

export function ControlSingleSelectFieldOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSingleSelectFieldOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'],
    };
}

export function ControlSingleSelectFieldOptionToJSON(value?: ControlSingleSelectFieldOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'text': value.text,
    };
}

